// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';

export const getDyRecommendations = (state) => state.DyRecommendations;

export const getIsLoading = createSelector(
  [getDyRecommendations, (state, page) => page],
  (recommendations, page) => {
    return recommendations?.[page]?.loading || false;
  }
);

export const getPDP1Rec = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.pdp?.pdp1 || {};
});

export const getPDP2Rec = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.pdp?.pdp2 || {};
});

export const getPDPRecentlyViewed = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.pdp?.pdpRecentlyViewed || {};
});

export const getPDPPLARec = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.pdp?.ab_pdp_pla || {};
});

export const getPDPOOSRec = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.pdp?.ab_pdp_oos || {};
});

export const getATB1Rec = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.added_to_bag?.added_to_bag1 || {};
});

export const getCart1Rec = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.cart?.cart1 || {};
});

export const getCart2Rec = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.cart?.cart2 || {};
});

export const getHomepage1Rec = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.home?.homepage1 || {};
});

export const getOrderDetailsRec = createSelector(getDyRecommendations, (recommendations) => {
  return recommendations?.order_details?.order_details || {};
});
